import cartDataSummaryHtml from './cartdatasummary.component.html';
import './cartdatasummary.component.scss';

class CartDataSummaryController {
    constructor($scope, $sce, CartService) {
        'ngInject';
        this.$scope = $scope;
        this.$sce = $sce;
        this.service = CartService;
        this.summary = null;
        this.items = [];

        this.$scope.keyLength = function (obj) {
            return Object.keys(obj).length;
        }
    }

    $onInit() {
        if (!this.service.loaded) {
            this.service.load().then(
                () => {
                    this.items = angular.copy(this.service.items);
                    this.summary = angular.copy(this.service.summary);
                }
            );
        }
    }
}

let cartDataSummaryComponent = {
    bindings: {},
    template: cartDataSummaryHtml,
    controller: CartDataSummaryController
}

export default cartDataSummaryComponent;
